.card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--mantine-spacing-md);
  border: 1px solid var(--mantine-color-gray-3);
  border-radius: var(--mantine-radius-md);
  background: var(--mantine-color-white);
  cursor: pointer;
}

.cardSelected {
  border-color: var(--mantine-color-blue-6);
}

.carrierInfo {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pricing {
  display: flex;
  align-items: center;
  gap: var(--mantine-spacing-lg);
}

.priceBlock {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
